// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticker-img[data-v-d64655e0]{transition-property:all;transition-duration:.3s;transition-timing-function:cubic-bezier(.4,0,.2,1);min-width:60px;max-height:55px}@media (min-width:992px){.sticker-img[data-v-d64655e0]{max-height:70px}}@media (min-width:1160px){.sticker-img[data-v-d64655e0]{max-height:82px}}@media (min-width:992px){.nav-fixed-container .sticker-img[data-v-d64655e0]{max-height:60px}}", ""]);
// Exports
module.exports = exports;
